import React, {Component} from 'react';
import {
  BrowserRouter as Router,
  Route,
} from 'react-router-dom';

import Navigation from '../Navigation';
import LandingPage from '../Landing';
import SignUpPage from '../SignUp';
import SignInPage from '../SignIn';
import AccountPage from '../Account';
import AdminPage from '../Admin';
import CreateComplainPage from '../Complains/CreateComplain';
import * as routes from '../../constants/routes';
import Logo from "../Logo";
import { Container } from 'reactstrap';

import "./index.css";
import AdminUsers from '../Users/UsersTable';
import EditUser from '../Users/UserForm';
import EditUserCredentials from '../Users/UsersCredentials';

class Layout extends Component {
    render(){
        return(
            <Router>
                <div className="layout">
                    <div className="jumbotron text-center header">
                        <Logo></Logo>
                    </div>
                    <Container>
                        <Navigation />
                        <Route exact path={routes.LANDING} component={() => <CreateComplainPage />} />
                        <Route exact path={routes.CREATE_USER} component={() => <SignUpPage />} />
                        <Route exact path={routes.ACCOUNT} component={() => <AccountPage />} />
                        <Route exact path={routes.ADMIN} component={()=> <AdminPage />} /> 
                        <Route exact path={routes.SIGN_IN} component={() => <SignInPage />} />
                        <Route exact path={routes.CREATE_COMPLAIN} component={()=> <CreateComplainPage />} />
                        <Route exact path={routes.ALL_USERS} component={()=><AdminUsers />} />
                        <Route exact path={routes.EDIT_USER + '/:userId'} component={EditUser} />
                        <Route exact path={routes.EDIT_USER_PASSWORD + '/:userId'} component={EditUserCredentials} />
                    </Container>
                </div>
            </Router>
        )    
    }
}

export default Layout;


// WEBPACK FOOTER //
// ./src/components/Layout/index.js